import React from 'react';

export default function CapMeter({ label, current, limit, warn, blocked, testId, unitSuffix }) {
  const unlimited = limit === null || limit === undefined;
  const pct = unlimited || !limit ? 0 : Math.min(100, Math.round((current / limit) * 100));
  const barColor = blocked ? '#C93434' : warn ? '#B86500' : '#146BFF';
  const trackBg = blocked ? '#FEECEC' : warn ? '#FFF6E5' : '#EFF5FF';
  const valueColor = blocked ? '#C93434' : warn ? '#B86500' : '#0B1B46';

  return (
    <div className="mb-2" data-testid={testId}>
      <div className="flex items-center justify-between mb-1">
        <span className="text-[11px] font-bold text-[#5B6472] uppercase tracking-wide">{label}</span>
        <span className="text-[13px] font-extrabold" style={{ color: valueColor }} data-testid={testId ? `${testId}-value` : undefined}>
          {unlimited ? 'Unlimited' : `${current} / ${limit}${unitSuffix ? ` ${unitSuffix}` : ''}`}
        </span>
      </div>
      {!unlimited && (
        <div className="h-2 rounded-full overflow-hidden" style={{ backgroundColor: trackBg }} data-testid={testId ? `${testId}-track` : undefined}>
          <div className="h-2 rounded-full transition-all duration-300" style={{ width: `${pct}%`, backgroundColor: barColor }} />
        </div>
      )}
    </div>
  );
}
